import { Injectable }                        from "@angular/core";
import { CONFIGURATION }                     from "../../../app.constants";
import {User, AccountWorkflow }              from "../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../services/shared";

@Injectable()
export class AccountWorkflowService {

    constructor(private httpData: HttpDataService) { }

    public getAccountWorkflowByTaskId(taskId: string): Observable<User> {
   
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}accountWorkflow/task/${taskId}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <AccountWorkflow[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public submitAccountWorkflow(accountWorkflow: AccountWorkflow): Observable<boolean> {
       let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}accountWorkflow`;

        return Observable.create((observer) => {
            this.httpData.post(dataUrl, JSON.stringify(accountWorkflow))
                .map(response => <boolean>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow/account/accountWorkflow.service.ts